import React, { useState } from 'react';
import cx from 'classnames';
import { isValidPhone, TextField, Button, isMobileDevice } from 'utils';

import styles from './phone.module.scss';

function Phone({ loading, error, onSubmit }) {
    const [phone, setPhone] = useState('');
    const isMobile = isMobileDevice();
    const height = 0.32 * window.screen.width;

    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>Sign in</p>
            <TextField
                error={error}
                value={phone}
                className={cx(styles.phone, error ? styles.error : null)}
                label="Phone Number"
                placeholder="99 999 999 99"
                width={isMobile ? 200 : height < 380 ? 300 : 340}
                onChange={(e) => setPhone(e.target.value)}
            />
            <Button
                loading={loading}
                label="Get OTP"
                className={styles.button}
                width={isMobile ? 200 : height < 380 ? 300 : 340}
                disabled={!isValidPhone(phone)}
                onClick={() => onSubmit(phone)}
            />
        </div>
    );
}

export default Phone;
